
var LocationUtil = {

	locations : [
            {'name' : 'Home' , 'label' : 'Dashboard', 'display' : '', 'link' : '/Home', 'moreClass' : '', 'sub' : ''},
            {'name' : 'Users' , 'label' : 'Users', 'display' : '', 'link' : '/Users', 'moreClass' : 'SideBar-Small', 'sub' : 'Home'},
            {'name' : 'Goals' , 'label' : 'Goals', 'display' : '', 'link' : '/Goals', 'moreClass' : 'SideBar-Small', 'sub' : 'Home'},
            {'name' : 'BuildSkills' , 'label' : 'Build Skills', 'display' : '', 'link' : '/BuildSkills', 'moreClass' : 'SideBar-Small', 'sub' : 'Home'},
            {'name' : 'StrategicGoals' , 'label' : 'Strategic Goals', 'display' : '', 'link' : '/StrategicGoals', 'moreClass' : '', 'sub' : ''}, 
            {'name' : 'Recommendations' , 'label' : 'Recommendations', 'display' : '', 'link' : '/Recommendations', 'moreClass' : '', 'sub' : ''},
            {'name' : 'AppConfiguration', 'label' : 'App Configuration', 'display' : '', 'link' : '/AppConfiguration', 'moreClass' : '', 'sub' : ''},
            {'name' : 'Settings' , 'label' : 'Settings', 'display' : '', 'link' : '/Settings', 'moreClass' : '', 'sub' : ''},
            //{'name' : 'UserSupport', 'label' : 'User Support', 'display' : '', 'link' : '/UserSupport', 'moreClass' : '', 'sub' : ''},
            {'name' : 'Logout' , 'label' : 'Logout', 'display' : '', 'link' : '/Logout', 'moreClass' : '', 'sub' : ''},
            {'name' : 'Zipcodes', 'label' : 'Zipcodes', 'display' : '', 'link' : '', 'moreClass' : '', 'sub' : 'Users'},
            {'name' : 'FIs', 'label' : 'FIs', 'display' : '', 'link' : '', 'moreClass' : '', 'sub' : 'Users'}
            ],

    getLocationByLabel : function(label) {
    	var selectedLocation = {};

    	for(var locKey in LocationUtil.locations) {
    		const location = LocationUtil.locations[locKey];

    		if(label.indexOf(location.label) > -1) {
				if(location.label === label) selectedLocation = location;
				else if (Object.keys(selectedLocation).length === 0) selectedLocation = location;
			}
    	}

    	return selectedLocation;
    },

    getSupers : function(subLoc) {
        for(var locKey in LocationUtil.locations) {
            const location = LocationUtil.locations[locKey];

            if(location.name === subLoc.sub) {
                var superArray = [location.name];
                if(location.sub.length) {
                    superArray = superArray.concat(LocationUtil.getSupers(location));
                }

                return superArray;
            }
        }

        return [];
    }
}


export default LocationUtil;